// extracted by mini-css-extract-plugin
export default {"legalText":"legal_legalText__fTeDL"};